export default __webpack_public_path__ + "static/media/DouglasLopes_02.717a66a2.jpg";